// ScheduleForm.jsx — when + quiet hours + frequency cap
import React from 'react';
import { ButtonGroup, Button, FormGroup, Input, Label } from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';

// Same read-only input pattern as ManageOrder — prevents free-form typing
// so users can only pick from the calendar/time list.
const DatepickerInput = ({ ...props }) => (
  <input type="text" {...props} readOnly />
);

const ScheduleForm = ({ value, onChange }) => {
  const v = value || {
    type: 'sendAt',
    sendAt: Date.now() + 60 * 60 * 1000, // default: 1h from now
    timezone: 'Asia/Dubai',
    quietHours: { startHour: 22, endHour: 8 },
    frequencyCapHours: 24,
  };

  const setType = (t) => {
    if (t === 'sendNow') onChange({ ...v, type: 'sendNow', sendAt: Date.now() });
    else onChange({ ...v, type: 'sendAt', sendAt: v.sendAt || Date.now() + 60 * 60 * 1000 });
  };
  const setSendAt = (ms) => onChange({ ...v, sendAt: ms });
  const setStartHour = (h) => onChange({ ...v, quietHours: { ...v.quietHours, startHour: h } });
  const setEndHour = (h) => onChange({ ...v, quietHours: { ...v.quietHours, endHour: h } });
  const setFreqCap = (h) => onChange({ ...v, frequencyCapHours: h });

  return (
    <div>
      <FormGroup>
        <Label className="d-block">When to send</Label>
        <ButtonGroup size="sm">
          <Button color="primary" outline={v.type !== 'sendNow'} onClick={() => setType('sendNow')}>
            Send now
          </Button>
          <Button color="primary" outline={v.type !== 'sendAt'} onClick={() => setType('sendAt')}>
            Schedule for later
          </Button>
        </ButtonGroup>
      </FormGroup>

      {v.type === 'sendAt' && (
        <FormGroup>
          <Label className="small">Send at (Asia/Dubai)</Label>
          <DatePicker
            popperClassName="redatepicker"
            customInput={<DatepickerInput />}
            selected={moment(v.sendAt || Date.now()).toDate()}
            onChange={(date) => setSendAt(date ? moment(date).valueOf() : Date.now())}
            minDate={new Date()}
            showTimeSelect
            timeFormat="hh:mm a"
            timeIntervals={15}
            timeCaption="time"
            dateFormat="dd/MM/yyyy hh:mm a"
          />
        </FormGroup>
      )}

      <FormGroup>
        <Label>Quiet hours <span className="text-muted small">(skip users between these times, Asia/Dubai)</span></Label>
        <div className="d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
          <div style={{ minWidth: 120 }}>
            <DatePicker
              popperClassName="redatepicker"
              customInput={<DatepickerInput />}
              selected={moment().hour(v.quietHours.startHour).minute(0).toDate()}
              onChange={(date) => setStartHour(date ? moment(date).hour() : 0)}
              showTimeSelect
              showTimeSelectOnly
              timeFormat="hh:mm a"
              timeIntervals={60}
              timeCaption="Start"
              dateFormat="hh:mm a"
            />
          </div>
          <span className="text-muted">to</span>
          <div style={{ minWidth: 120 }}>
            <DatePicker
              popperClassName="redatepicker"
              customInput={<DatepickerInput />}
              selected={moment().hour(v.quietHours.endHour).minute(0).toDate()}
              onChange={(date) => setEndHour(date ? moment(date).hour() : 0)}
              showTimeSelect
              showTimeSelectOnly
              timeFormat="hh:mm a"
              timeIntervals={60}
              timeCaption="End"
              dateFormat="hh:mm a"
            />
          </div>
          <span className="text-muted small">e.g. 10 PM to 8 AM = no sends overnight</span>
        </div>
      </FormGroup>

      <FormGroup>
        <Label>Frequency cap <span className="text-muted small">(skip users who got any campaign in last N hours)</span></Label>
        <div className="d-flex align-items-center">
          <Input
            type="number" min={0} max={720}
            value={v.frequencyCapHours}
            onChange={(e) => setFreqCap(parseInt(e.target.value, 10) || 0)}
            style={{ width: 100 }}
          />
          <span className="ml-2 text-muted small">hours (0 = no cap)</span>
        </div>
      </FormGroup>
    </div>
  );
};

export default ScheduleForm;
